






































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import formatCurrency from "@/filters/currency";
import Colors from "@/helpers/Colors";
import ReportModel from "@/model/Report";

import { namespace } from "vuex-class";

import { GChartsCurrency } from "@/types/global.d";

const formatCurrencyData = (v: number): GChartsCurrency => ({
  v,
  f: formatCurrency(v)
});

const AppStore = namespace("App");

@Component({
  name: "SummaryCharts"
})
export default class SummaryCharts extends Vue {
  // public chartOptions: {} = chartOptions;

  @Prop()
  readonly value!: ReportModel;

  @AppStore.State
  reportYear!: number;

  public summaryChartData = [
    ["Obszar", "Kwota"],
    ["Świadczenia na rzecz organizacji ochrony zdrowia", 0],
    ["Świadczenia na rzecz przedstawicieli zawodów medycznych", 0],
    ["Świadczenia na działalność badawczo rozwojową", 0]
  ];

  public hcoChartData = [
    ["Obszar", "Kwota"],
    ["Wynagrodzenie z tytułu świadczonych usuług", 0],
    ["Koszty poniesione w związku z wydarzeniami", 0],
    ["Darowizny", 0]
  ];

  public hcpChartData = [
    ["Obszar", "Kwota"],
    ["Wynagrodzenie z tytułu świadczonych usług", 0],
    ["Koszty poniesione w związku z wydarzeniami", 0]
  ];

  @Watch("value", { immediate: true, deep: true })
  setData(newValue: any) {
    Vue.set(this.summaryChartData[1], 1, formatCurrencyData(newValue.hcoTotal));
    Vue.set(this.summaryChartData[2], 1, formatCurrencyData(newValue.hcpTotal));
    Vue.set(this.summaryChartData[3], 1, formatCurrencyData(newValue.rndTotal));
    Vue.set(
      this.hcoChartData[1],
      1,
      formatCurrencyData(newValue.hcoSalaryTotal)
    );
    Vue.set(
      this.hcoChartData[2],
      1,
      formatCurrencyData(newValue.hcoEventTotal)
    );
    Vue.set(
      this.hcoChartData[3],
      1,
      formatCurrencyData(newValue.hcoDonationTotal)
    );
    Vue.set(
      this.hcpChartData[1],
      1,
      formatCurrencyData(newValue.hcpSalaryTotal)
    );
    Vue.set(
      this.hcpChartData[2],
      1,
      formatCurrencyData(newValue.hcpEventTotal)
    );
  }

  get isMobile() {
    const screenWidth = window.innerWidth;
    const mobile = screenWidth < 960;
    return mobile;
  }

  get colors() {
    return [
      { color: Colors.Secondary.hex(), offset: 0.01 },
      { color: Colors.PrimaryLight.hex(), offset: 0.01 },
      { color: Colors.PrimaryDark.hex(), offset: 0.01 }
    ];
  }

  get chartOptions() {
    return {
      fontName: "Source Sans Pro",
      pieSliceText: "percent",
      pieSliceTextStyle: {
        color: "white",
        fontSize: 24
      },
      pieStartAngle: 0,
      height: "400px",
      chartArea: {
        width: "90%",
        height: "90%"
      },
      legend: {
        position: this.isMobile ? "none" : "labeled",
        labeledValueText: "value",
        textStyle: {
          color: "#000"
        }
      },

      tooltip: {
        trigger: "none"
      },
      slices: this.colors
    };
  }

  // get summaryChartData(): Array<Array<any>> {
  //   Vue.set(summaryChartData[1], 1, formatCurrencyData(this.value.hcoTotal));
  //   Vue.set(summaryChartData[2], 1, formatCurrencyData(this.value.hcpTotal));
  //   Vue.set(summaryChartData[3], 1, formatCurrencyData(this.value.rndTotal));
  //   return summaryChartData;
  // }

  // get hcoChartData(): Array<Array<any>> {
  //   Vue.set(hcoChartData[1], 1, formatCurrencyData(this.value.hcoEventTotal));
  //   Vue.set(hcoChartData[2], 1, formatCurrencyData(this.value.hcoSalaryTotal));
  //   Vue.set(
  //     hcoChartData[3],
  //     1,
  //     formatCurrencyData(this.value.hcoDonationTotal)
  //   );
  //   return hcoChartData;
  // }

  // get hcpChartData(): Array<Array<any>> {
  //   Vue.set(hcpChartData[1], 1, formatCurrencyData(this.value.hcpEventTotal));
  //   Vue.set(hcpChartData[2], 1, formatCurrencyData(this.value.hcpSalaryTotal));
  //   return hcpChartData;
  // }

  formatCurrency(value: number) {
    return formatCurrency(value);
  }
}
